const whatsappNumber = '5511948948561'
const defaultMessage = 'Olá! Gostaria de falar com um Especialista da Master.'

export function WhatsAppFloatingButton() {
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar conosco pelo WhatsApp"
      className="fixed bottom-6 right-4 sm:right-6 z-50 group focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-green-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
    >
      <span className="sr-only">Fale com a Master Caça Vazamentos pelo WhatsApp</span>
      <div className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-green-500 shadow-lg transition-transform duration-300 ease-out group-hover:scale-110">
        <div className="pointer-events-none absolute inset-0 rounded-full bg-green-500 opacity-60 blur-xl animate-pulse group-hover:opacity-80" aria-hidden="true" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="relative w-7 h-7 sm:w-8 sm:h-8 text-white"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M16 2.887c-7.11 0-12.887 5.775-12.887 12.887 0 2.273.593 4.465 1.723 6.418L2.887 29l6.99-1.812c1.89 1.035 4.047 1.582 6.123 1.582 7.11 0 12.887-5.775 12.887-12.887S23.11 2.887 16 2.887zm0 23.516a10.55 10.55 0 0 1-5.383-1.477l-.386-.229-4.152 1.076 1.105-4.049-.251-.416a10.516 10.516 0 0 1-1.601-5.487c0-5.812 4.73-10.545 10.546-10.545 5.812 0 10.545 4.733 10.545 10.545S21.812 26.403 16 26.403zm5.77-7.913c-.315-.158-1.864-.92-2.154-1.028-.288-.105-.498-.158-.709.158-.21.315-.814 1.028-.998 1.24-.182.21-.363.237-.678.08-.315-.158-1.33-.49-2.532-1.562-.936-.836-1.563-1.868-1.744-2.183-.182-.315-.02-.485.137-.643.14-.138.315-.363.473-.543.158-.182.21-.315.315-.525.105-.21.053-.395-.026-.553-.08-.158-.709-1.712-.971-2.343-.256-.613-.518-.53-.709-.539l-.603-.012c-.21 0-.553.08-.842.395-.288.315-1.107 1.08-1.107 2.635 0 1.554 1.133 3.057 1.29 3.27.158.21 2.232 3.41 5.41 4.782.757.326 1.348.521 1.808.667.76.242 1.452.208 2.002.126.611-.091 1.864-.76 2.128-1.494.263-.734.263-1.363.184-1.494-.077-.131-.284-.21-.6-.368z" />
        </svg>
        <span className="absolute -top-2 -left-2 sm:-left-3 sm:-top-3 rounded-full bg-white/90 px-2 py-1 text-xs font-semibold text-green-600 shadow group-hover:bg-white">
          WhatsApp
        </span>
      </div>
    </a>
  )
}

export default WhatsAppFloatingButton
